@if (0 !== richBaseValues.length) {
    <app-state-box state="warning">
        <app-state-box-headline>
            <app-icon class="headline-icon"
                      name="exclamation_circle"
                      centered />
            {{ boxHeadline }}
        </app-state-box-headline>

        @for (richBaseValue of richBaseValues; track richBaseValue) {
            <div>
                {{richBaseValue.label}}:
                <app-rendered-value [unit]="richBaseValue.unit"
                                    [value]="richBaseValue.value" />
            </div>
        }

        @if (isWinery) {
            <p i18n="@@futureBaseValuesSummary.wineryNote">
                Die Eingaben beziehen sich auf die Grunddaten des Vorjahres. Sollten
                Sie die Bewirtschaftungsfläche des Vorjahres um über 10% bzw. 3
                Hektar überschreiten, weisen wir darauf hin, dass eine
                Vorortkontrolle erforderlich ist.
            </p>
        }
    </app-state-box>
}
